
export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';
export const STANDARD_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
